export default __webpack_public_path__ + "static/media/error-icon.1639bbf3.svg";